"use client";
import React, { createContext, useContext, useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import HomeLine from "../../../public/assets/images/home_line.png";
import { FaArrowDown, FaArrowRight } from "react-icons/fa";
import { getStrapiMedia } from "@aicodepro/web-builder-utils";

interface Button {
  id: string;
  url: string;
  text: string;
  type: string;
  newTab: boolean;
  isLive: boolean;
}
interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}
interface ImageComparisionProps {
  data: {
    id: number;
    title: string;
    description: string;
    image1: Picture;
    image2: Picture;
    button: Button;
    isLive: boolean;
    isReverse: boolean;
    useH1Tag?: boolean;
  };
}

export default function ImageComparision({ data }: ImageComparisionProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const imgUrl1 = getStrapiMedia(data?.image1?.data?.attributes?.url);
  const imgUrl2 = getStrapiMedia(data?.image2?.data?.attributes?.url);

  return (
    data?.isLive && (
      <section className="mx-auto px-6 items-center lg:py-6 md:py-12 py-8 bg-white overflow-hidden">
        {data?.title && (
          <div className="banner text-center mb-[50px] relative">
            {data.description && (
              <span className="text-[14px] text-th-subtitle-col">
                {data.description}
              </span>
            )}
            {data?.useH1Tag ? (
              <h1 className="text-center mt-[5px] 2xl:text-[35px] xl:text-[33px] lg:text-[30px] md:text-[26px] sm:text-[24px] text-[22px] mb-0">
                {data.title}
              </h1>
            ) : (
              <h2 className="text-center mt-[5px] 2xl:text-[35px] xl:text-[33px] lg:text-[30px] md:text-[26px] sm:text-[24px] text-[22px] font-bold mb-0">
                {data.title}
              </h2>
            )}
          </div>
        )}
        <div
          className={`mx-auto flex flex-col md:flex-row lg:flex-row ${
            data.isReverse ? "lg:flex-row-reverse" : ""
          } items-center justify-center lg:w-[900px] xl:w-[1200px] w-[360px] md:w-[700px] px-4 lg:gap-20 xl:gap-20 md:gap-10 gap-5`}
        >
          <div className="lg:w-1/2 bg-transparent lg:mt-0 xl:mt-0 md:mt-0 mt-0 rounded-lg opacity-100 flex items-center justify-center rounded-md transition-transform duration-300 hover:scale-110">
            <Image
              src={imgUrl1 || ""}
              alt={data?.image1?.data?.attributes?.alternativeText || "compare-img"}
              width={400}
              height={300}
              className="lg:object-cover mg:object-cover xl:object-cover object-contain lg:h-[250px] xl:h-auto md:h-auto lg:w-[275px] md:w-[450px] w-[350px] rounded-md"
            />
          </div>

          <div className="flex items-center justify-center py-2 text-th-link-col text-3xl lg:py-4 lg:px-4 bg-transparent">
            {isMobile ? <FaArrowDown /> : <FaArrowRight />}
          </div>

          <div className="lg:w-1/2 bg-transparent lg:mt-0 xl:mt-0 md:mt-0 mt-0 rounded-lg opacity-100 flex items-center justify-center rounded-md transition-transform duration-300 hover:scale-110">
            <Image
              src={imgUrl2 || ""}
              alt={data?.image2?.data?.attributes?.alternativeText || "compare-img"}
              width={400}
              height={300}
              className="lg:object-cover mg:object-cover xl:object-cover object-contain lg:h-[250px] xl:h-auto md:h-auto lg:w-[275px] md:w-[450px] w-[350px] rounded-md"
            />
          </div>
        </div>
        {/* <div className="flex items-center justify-center text-center px-4 py-4 pb-4">
          {data?.button?.isLive && (
            <Link
              href={data?.button?.url || ""}
              target={data?.button?.newTab ? "_blank" : "_self"}
              className="px-8 py-3 text-lg font-normal rounded-full bg-th-btncol-1 text-th-btntext-1 hover:bg-th-btncol-2 shadow-sm transition-colors duration-200 hover:shadow-none"
            >
              {data?.button?.text}
            </Link>
          )}
        </div> */}
      </section>
    )
  );
}
